import './jquery'
import './bootstrap-datepicker.min.js'
import './locales/bootstrap-datepicker.el.min.js'
import './jquery.touchSwipe.min.js'
import './moment'
import './datepicker-in-fullscreen.js'

export default {
  bind: function (el, binding, vnode) {

    let options = {}

    if (binding.expression) {
      const toJSON = JSON.stringify(binding.expression);
      options = JSON.parse(toJSON);
    }

    $(el).datepickerInFullscreen({
      format: options.format,
      blockScroll: false,
      additionalTarget: options.additionalTarget,
      additionalTargetFormat: options.additionalTargetFormat,
      fakeInput: options.fakeInput,
      fakeInputFormat: options.fakeInputFormat,
      todayWord: options.todayWord,
      clearWord: options.clearWord,
      closeWord: options.closeWord,
      template: `<div class="datepicker-in-fullscreen-modal">
                  <div class="datepicker-in-fullscreen-content">
                    <div class="datepicker-in-fullscreen-controls">
                      <a class="dpifs-close">
                        <i class="icon-close"></i>
                      </a>
                    </div>
                    <div class="datepicker-in-fullscreen"></div>
                  </div>
                </div>
                <div class="datepicker-in-fullscreen-background"></div>`,
      datepicker: {
        datesDisabled: options.datesDisabled,
        daysOfWeekDisabled: options.daysOfWeekDisabled,
        daysOfWeekHighlighted: options.daysOfWeekHighlighted,
        startDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
        endDate: options.endDate,
        weekStart: 1,
        todayHighlight: true,
        language: options.language
      },
      beforeOpen: function (modal, settings) {
        el.dispatchEvent(new Event('before-open'))
      },
      beforeClose: function (modal, settings) {
        el.dispatchEvent(new Event('before-close'))
      },
      onChange: function (modal, settings) {
        el.dispatchEvent(new Event('input'))
      }
    })
  },

  inserted: function (el) { }
}